export default "__VITE_ASSET__BvqaFyjl__"